import styled from 'styled-components'

const TimesheetSc = styled.div`
  width: 90vw;
  height :100vh;
  position: absolute;
  top: 55px;
  padding: 10px;
  display: flex;
  flex-direction: column;

  gap: 5rem;
  h3 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .form_container {
    width: 100%;
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
  }
  .submit-button {
    background-color: #007bff; /* Blue background color */
    color: #fff; /* White text color */
    border: none; /* Remove the border */
    padding: 10px 20px; /* Add some padding for spacing */
    cursor: pointer; /* Change cursor to a pointer on hover */
    border-radius: 5px; /* Rounded corners */
  }

  .submit-button:hover {
    background-color: #0056b3; /* Darker blue on hover */
  }
  .form_group_button {
    margin: 0 auto;
  }
  .form_sub{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:1rem
  }
`
export default TimesheetSc
